import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import React, { FunctionComponent } from 'react';

import { User } from '../../apollo/__generated__/graphql';

interface UserSelectProps {
  users: Pick<
    User,
    'id' | 'firstname' | 'lastname' | 'nickname' | 'studies' | 'studyTown'
  >[];
  selectedUserId: string | undefined;
  onUserSelect: (userId: string) => void;
}

export const UserSelect: FunctionComponent<UserSelectProps> = ({
  users,
  selectedUserId,
  onUserSelect,
}) => {
  const onChange = (event: SelectChangeEvent<string>) => {
    onUserSelect(event.target.value);
  };

  return (
    <FormControl fullWidth>
      <InputLabel id="user-select">Participant</InputLabel>
      <Select
        labelId="user-select"
        value={selectedUserId}
        onChange={onChange}
        label="Participant"
      >
        {users.map((user) => (
          <MenuItem key={user.id} value={user.id}>
            {user.firstname} {user.lastname?.substring(0, 1)}.
            {user.nickname ? ` "${user.nickname}"` : null} {user.studies}{' '}
            {user.studyTown}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
};
